<template>
  <div class="app-container ks-device-manage">
    <!-- 一、搜索区域 -->
    <el-card shadow="never" class="search-card">
      <el-form :inline="true" size="small" @keyup.enter.native="toFilter">
        <el-form-item label="出厂编号">
          <el-input v-model="filter.factory_no" placeholder="请输入出厂编号" clearable style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="台区名称">
          <el-input v-model="filter.transformer_name" placeholder="请输入台区名称" clearable style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="一体柜名称">
          <el-input v-model="filter.cabinet_name" placeholder="请输入一体柜名称" clearable style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="KS终端名称">
          <el-input v-model="filter.name" placeholder="请输入终端名称" clearable style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="SIM卡号">
          <el-input v-model="filter.sim_no" placeholder="请输入SIM卡号" clearable style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="toFilter">查询</el-button>
          <el-button icon="el-icon-refresh" @click="onResetFilter">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="onAdd">添加</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 二、列表区域 -->
    <el-card shadow="never" class="table-card">
      <div slot="header" class="card-header">
        <span class="card-title">KS终端列表</span>
        <span class="card-sub-title">共 {{ pageParams.total }} 个终端</span>
      </div>

      <el-table :data="tableData" border stripe height="60vh" v-loading="loading">
        <el-table-column label="出厂编号" prop="factory_no" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="绑定台区信息" min-width="170" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div>{{ row.transformer_name || "-" }}</div>
            <div class="cell-sub" v-if="row.transformer_region">{{ row.transformer_region }}</div>
          </template>
        </el-table-column>
        <el-table-column label="安装的一体柜信息" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div>{{ row.cabinet_name || "-" }}</div>
            <div class="cell-sub" v-if="row.cabinet_address">{{ row.cabinet_address }}</div>
          </template>
        </el-table-column>
        <el-table-column label="终端名称" prop="name" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column label="SIM卡号" prop="sim_no" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="软件版本号" prop="sw_version" width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="SIM卡网络运营商" width="140" align="center">
          <template slot-scope="{ row }">{{ formatOperator(row.sim_operator) }}</template>
        </el-table-column>
        <el-table-column label="SIM卡网络信号等级" width="150" align="center">
          <template slot-scope="{ row }">{{ formatSignal(row.sim_signal) }}</template>
        </el-table-column>
        <el-table-column label="实时监测上报频率" width="150" align="center">
          <template slot-scope="{ row }">{{ formatInterval(row.report_interval) }}</template>
        </el-table-column>
        <el-table-column label="负荷开关属性上报频率" width="170" align="center">
          <template slot-scope="{ row }">{{ formatInterval(row.switch_report_interval) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onDetail(row)">详情</el-button>
            <el-button type="text" @click="onEdit(row)">编辑</el-button>
            <el-button type="text" class="btn-danger" @click="onDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="my-pagination">
        <el-pagination
          background
          layout="sizes,total,prev,pager,next,jumper"
          :total="pageParams.total"
          :page-size="pageParams.limit"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="pageParams.page"
          @size-change="onSizeChange"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 三、添加 / 编辑 Drawer -->
    <el-drawer
      :title="isEdit ? '编辑KS终端' : '添加KS终端'"
      :visible.sync="drawerVisible"
      size="50%"
      :wrapper-closable="false"
      @closed="onDrawerClosed"
    >
      <div class="drawer-body">
        <el-form ref="ksForm" :model="form" :rules="formRules" label-width="160px" size="small">
          <el-form-item label="终端名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入终端名称" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="出厂编号" prop="factory_no">
            <el-input v-model="form.factory_no" placeholder="请输入出厂编号" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="绑定台区" prop="transformer_id">
            <el-input v-model="form.transformer_name" readonly placeholder="请选择绑定的台区">
              <el-button slot="append" icon="el-icon-more" @click="onOpenTransformerDialog"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="安装于一体柜" prop="cabinet_id">
            <el-select
              ref="cabinetSelect"
              v-model="form.cabinet_id"
              placeholder="请选择一体柜"
              style="width: 100%"
              suffix-icon="el-icon-more"
              :loading="cabinetLoading"
              @change="onCabinetChange"
              @visible-change="onCabinetVisibleChange"
            >
              <el-option v-for="item in cabinetOptions" :key="item.ID" :label="item.name" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="isEdit">
            <el-form-item label="实时监测上报频率" prop="report_interval">
              <el-input-number
                v-model="form.report_interval"
                :min="1"
                :max="86400"
                :step="10"
                controls-position="right"
              ></el-input-number>
              <span class="form-unit">秒</span>
            </el-form-item>
            <el-form-item label="负荷开关属性上报频率" prop="switch_report_interval">
              <el-input-number
                v-model="form.switch_report_interval"
                :min="1"
                :max="86400"
                :step="10"
                controls-position="right"
              ></el-input-number>
              <span class="form-unit">秒</span>
            </el-form-item>
          </template>
          <el-form-item label="备注">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="drawerVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="onSubmit">保存</el-button>
      </div>
    </el-drawer>

    <!-- 四、台区选择弹窗 -->
    <el-dialog title="选择台区" :visible.sync="transformerDialogVisible" width="900px" append-to-body>
      <el-form :inline="true" size="small" @keyup.enter.native="onSearchTransformer">
        <el-form-item v-for="item in areaLevels" :key="item.level" :label="item.label">
          <el-select
            v-model="transformerFilter[item.key]"
            placeholder="全部"
            :disabled="isAreaDisabled(item.level)"
            style="width: 130px"
            @change="onAreaChange(item.level)"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="option in regionOptions[item.level]"
              :key="option.id"
              :label="option.Text"
              :value="option.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearchTransformer">查询</el-button>
          <el-button icon="el-icon-refresh" @click="onResetTransformerFilter">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="transformerList"
        border
        stripe
        height="360"
        highlight-current-row
        v-loading="transformerLoading"
        @row-click="onTransformerRowClick"
      >
        <el-table-column label="台区ID" prop="ID" width="160" align="center"></el-table-column>
        <el-table-column label="台区名称" prop="name" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="所属区域" prop="region_name" min-width="220" show-overflow-tooltip></el-table-column>
      </el-table>

      <div class="my-pagination">
        <el-pagination
          background
          small
          layout="total,prev,pager,next"
          :total="transformerTotal"
          :page-size="transformerLimit"
          :current-page="transformerPage"
          @current-change="onTransformerPageChange"
        ></el-pagination>
      </div>
      <div class="dialog-tip">单击列表中的台区即可选中并关闭弹窗</div>
    </el-dialog>

    <!-- 五、详情弹窗 -->
    <el-dialog title="KS终端详情" :visible.sync="detailVisible" width="720px" append-to-body>
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="出厂编号">{{ detailRow.factory_no || "-" }}</el-descriptions-item>
        <el-descriptions-item label="绑定台区信息">{{ detailRow.transformer_name || "-" }}</el-descriptions-item>
        <el-descriptions-item label="安装的一体柜信息">{{ detailRow.cabinet_name || "-" }}</el-descriptions-item>
        <el-descriptions-item label="终端名称">{{ detailRow.name || "-" }}</el-descriptions-item>
        <el-descriptions-item label="SIM卡号">{{ detailRow.sim_no || "-" }}</el-descriptions-item>
        <el-descriptions-item label="软件版本号">{{ detailRow.sw_version || "-" }}</el-descriptions-item>
        <el-descriptions-item label="SIM卡网络运营商">{{ formatOperator(detailRow.sim_operator) }}</el-descriptions-item>
        <el-descriptions-item label="SIM卡网络信号等级">{{ formatSignal(detailRow.sim_signal) }}</el-descriptions-item>
        <el-descriptions-item label="实时监测上报频率">{{ formatInterval(detailRow.report_interval) }}</el-descriptions-item>
        <el-descriptions-item label="负荷开关属性上报频率">
          {{ formatInterval(detailRow.switch_report_interval) }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailRow.remark || "-" }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRegionTreeApi,
  getTqViewPageListApi,
  getPowerCabinetList,
  getKsDeviceListApi,
  addKsDeviceApi,
  updateKsDeviceApi,
  deleteKsDeviceApi
} from "@/api/dev_archive"

// 区域级联层级：省 → 市 → 区/县 → 街道 → 社区 → 站点
const AREA_LEVELS = [
  { level: 0, key: "province", label: "省" },
  { level: 1, key: "city", label: "市" },
  { level: 2, key: "county", label: "区/县" },
  { level: 3, key: "street", label: "街道" },
  { level: 4, key: "community", label: "社区" },
  { level: 5, key: "estate", label: "站点" }
]

// SIM 卡网络运营商：10 未成功获取、11 联通、12 移动、13 电信、14 其他运营商
const KS_SIM_OPERATORS = {
  10: "未成功获取",
  11: "联通",
  12: "移动",
  13: "电信",
  14: "其他运营商"
}

// 上报频率默认值（单位：秒）
const KS_DEFAULT_REPORT_INTERVAL = 300

// 新建表单默认值
function createEmptyForm() {
  return {
    ID: "",
    name: "",
    factory_no: "",
    transformer_id: "",
    transformer_name: "",
    cabinet_id: "",
    cabinet_name: "",
    report_interval: KS_DEFAULT_REPORT_INTERVAL,
    switch_report_interval: KS_DEFAULT_REPORT_INTERVAL,
    remark: ""
  }
}

export default {
  name: "KSDeviceManage",
  data() {
    return {
      loading: false,
      saving: false,
      tableData: [],
      pageParams: {
        page: 1,
        limit: 10,
        total: 0
      },
      filter: {
        factory_no: "",
        transformer_name: "",
        cabinet_name: "",
        name: "",
        sim_no: ""
      },

      // 添加 / 编辑抽屉
      drawerVisible: false,
      isEdit: false,
      form: createEmptyForm(),
      formRules: {
        name: [{ required: true, message: "请输入终端名称", trigger: "blur" }],
        factory_no: [{ required: true, message: "请输入出厂编号", trigger: "blur" }],
        transformer_id: [{ required: true, message: "请选择绑定台区", trigger: "change" }],
        cabinet_id: [{ required: true, message: "请选择安装的一体柜", trigger: "change" }],
        report_interval: [{ required: true, message: "请输入实时监测上报频率", trigger: "blur" }],
        switch_report_interval: [{ required: true, message: "请输入负荷开关属性上报频率", trigger: "blur" }]
      },

      // 一体柜下拉选项
      cabinetOptions: [],
      cabinetLoading: false,

      // 台区选择弹窗
      transformerDialogVisible: false,
      transformerLoading: false,
      transformerList: [],
      transformerPage: 1,
      transformerLimit: 10,
      transformerTotal: 0,
      transformerFilter: {
        province: "",
        city: "",
        county: "",
        street: "",
        community: "",
        estate: ""
      },
      areaLevels: AREA_LEVELS,
      regionTree: [],
      regionOptions: [[], [], [], [], [], []],

      // 详情弹窗
      detailVisible: false,
      detailRow: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 统一取数：兼容 { data: [] }、{ outputData: {...} }、{ output: {...} }、{ list: [] } 等返回结构
    pickApiPayload(res) {
      if (!res) return {}
      if (res.outputData) return res.outputData
      if (res.output) return res.output
      if (res.data && !Array.isArray(res.data)) return res.data
      return res
    },

    /* ============ 列表 ============ */
    getData() {
      this.loading = true
      const params = {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        ...this.filter
      }
      getKsDeviceListApi(params).then((res) => {
        const payload = this.pickApiPayload(res)
        this.tableData = payload.data || payload.list || []
        this.pageParams.total = payload.total || payload.count || 0
      }).catch(() => {
        this.tableData = []
        this.pageParams.total = 0
      }).finally(() => {
        this.loading = false
      })
    },

    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },

    onResetFilter() {
      this.filter = {
        factory_no: "",
        transformer_name: "",
        cabinet_name: "",
        name: "",
        sim_no: ""
      }
      this.toFilter()
    },

    onPageChange(page) {
      this.pageParams.page = page
      this.getData()
    },

    onSizeChange(size) {
      this.pageParams.limit = size
      this.pageParams.page = 1
      this.getData()
    },

    formatOperator(val) {
      if (val === null || val === undefined || val === "") return "-"
      const name = KS_SIM_OPERATORS[val]
      return name ? `${val}（${name}）` : String(val)
    },

    formatSignal(val) {
      if (val === null || val === undefined || val === "") return "-"
      const signal = Number(val)
      if (isNaN(signal)) return "-"
      return `${signal} / 31`
    },

    formatInterval(val) {
      if (val === null || val === undefined || val === "") return "-"
      return `${val} 秒`
    },

    /* ============ 添加 / 编辑 ============ */
    onAdd() {
      this.isEdit = false
      this.form = createEmptyForm()
      this.cabinetOptions = []
      this.drawerVisible = true
      this.$nextTick(() => {
        if (this.$refs.ksForm) this.$refs.ksForm.clearValidate()
      })
    },

    onEdit(row) {
      this.isEdit = true
      this.form = Object.assign(createEmptyForm(), {
        ID: row.ID,
        name: row.name || "",
        factory_no: row.factory_no || "",
        transformer_id: row.transformer_id || "",
        transformer_name: row.transformer_name || "",
        cabinet_id: row.cabinet_id || "",
        cabinet_name: row.cabinet_name || "",
        report_interval: row.report_interval != null ? Number(row.report_interval) : KS_DEFAULT_REPORT_INTERVAL,
        switch_report_interval:
          row.switch_report_interval != null ? Number(row.switch_report_interval) : KS_DEFAULT_REPORT_INTERVAL,
        remark: row.remark || ""
      })
      // 先占位当前一体柜，再异步加载该台区下的一体柜选项
      this.cabinetOptions = row.cabinet_id ? [{ ID: row.cabinet_id, name: row.cabinet_name || row.cabinet_id }] : []
      this.drawerVisible = true
      this.$nextTick(() => {
        if (this.$refs.ksForm) this.$refs.ksForm.clearValidate()
        if (this.form.transformer_id) {
          this.loadCabinetOptions(this.form.transformer_id)
        }
      })
    },

    onDrawerClosed() {
      this.saving = false
      this.form = createEmptyForm()
      this.cabinetOptions = []
      if (this.$refs.ksForm) this.$refs.ksForm.clearValidate()
    },

    onSubmit() {
      this.$refs.ksForm.validate((valid) => {
        if (!valid) return
        const params = {
          ID: this.form.ID,
          name: this.form.name,
          factory_no: this.form.factory_no,
          transformer_id: this.form.transformer_id,
          cabinet_id: this.form.cabinet_id,
          remark: this.form.remark
        }
        // 编辑时才提交两项上报频率
        if (this.isEdit) {
          params.report_interval = this.form.report_interval
          params.switch_report_interval = this.form.switch_report_interval
        }
        this.saving = true
        const request = this.isEdit ? updateKsDeviceApi(params) : addKsDeviceApi(params)
        request.then(() => {
          this.$message.success(this.isEdit ? "修改成功" : "添加成功")
          this.drawerVisible = false
          if (!this.isEdit) this.pageParams.page = 1
          this.getData()
        }).catch(() => {
          this.$message.error("保存失败")
        }).finally(() => {
          this.saving = false
        })
      })
    },

    /* ============ 删除 / 详情 ============ */
    onDelete(row) {
      this.$confirm(`确定删除KS终端「${row.name || row.factory_no}」吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteKsDeviceApi({ ID: row.ID }).then(() => {
          this.$message.success("删除成功")
          if (this.tableData.length === 1 && this.pageParams.page > 1) {
            this.pageParams.page -= 1
          }
          this.getData()
        }).catch(() => {
          this.$message.error("删除失败")
        })
      }).catch(() => {})
    },

    onDetail(row) {
      this.detailRow = row
      this.detailVisible = true
    },

    /* ============ 台区选择弹窗 ============ */
    onOpenTransformerDialog() {
      this.transformerDialogVisible = true
      if (!this.regionTree.length) {
        this.loadRegionTree()
      }
      this.transformerPage = 1
      this.onSearchTransformer()
    },

    loadRegionTree() {
      return getRegionTreeApi().then((res) => {
        const payload = this.pickApiPayload(res)
        const tree = (payload && (payload.tree || payload)) || []
        this.regionTree = Array.isArray(tree) ? tree : []
        this.buildRegionOptions()
      }).catch(() => {
        this.regionTree = []
        this.buildRegionOptions()
      })
    },

    // 根据各级当前选中值，逐级下钻生成每级下拉选项
    buildRegionOptions() {
      const options = this.areaLevels.map(() => [])
      let currentList = this.regionTree || []
      options[0] = currentList
      for (let i = 1; i < this.areaLevels.length; i++) {
        const parentKey = this.areaLevels[i - 1].key
        const parentId = this.transformerFilter[parentKey]
        const parentNode = parentId ? currentList.find((node) => node.id === parentId) : null
        currentList = (parentNode && parentNode.children) || []
        options[i] = currentList
      }
      this.regionOptions = options
    },

    // 上级未选择（或选择了全部）时，下级不可查询
    isAreaDisabled(level) {
      if (level <= 0) return false
      const parentKey = this.areaLevels[level - 1].key
      return !this.transformerFilter[parentKey]
    },

    onAreaChange(level) {
      for (let i = level + 1; i < this.areaLevels.length; i++) {
        this.transformerFilter[this.areaLevels[i].key] = ""
      }
      this.buildRegionOptions()
    },

    onResetTransformerFilter() {
      this.areaLevels.forEach((item) => {
        this.transformerFilter[item.key] = ""
      })
      this.buildRegionOptions()
      this.transformerPage = 1
      this.onSearchTransformer()
    },

    // 当前选中的最深层级区域（接口参数：level + region_id）
    getCurrentRegionParam() {
      let level = null
      let regionId = ""
      this.areaLevels.forEach((item) => {
        const value = this.transformerFilter[item.key]
        if (value) {
          level = item.level
          regionId = value
        }
      })
      return { level, region_id: regionId }
    },

    onSearchTransformer() {
      this.transformerLoading = true
      const region = this.getCurrentRegionParam()
      const params = {
        page: this.transformerPage,
        pagesize: this.transformerLimit
      }
      if (region.level !== null && region.region_id) {
        params.level = region.level
        params.region_id = region.region_id
      }
      getTqViewPageListApi(params).then((res) => {
        const payload = this.pickApiPayload(res)
        this.transformerList = payload.data || payload.list || []
        this.transformerTotal = payload.total || payload.count || 0
      }).catch(() => {
        this.transformerList = []
        this.transformerTotal = 0
      }).finally(() => {
        this.transformerLoading = false
      })
    },

    onTransformerPageChange(page) {
      this.transformerPage = page
      this.onSearchTransformer()
    },

    // 单击台区行：选中该台区并关闭弹窗
    onTransformerRowClick(row) {
      this.form.transformer_id = row.ID
      this.form.transformer_name = row.name || ""
      // 台区变化后已安装的一体柜失效，需重新选择
      this.form.cabinet_id = ""
      this.form.cabinet_name = ""
      this.cabinetOptions = []
      this.transformerDialogVisible = false
      this.$nextTick(() => {
        if (this.$refs.ksForm) this.$refs.ksForm.validateField("transformer_id")
      })
    },

    /* ============ 一体柜下拉 ============ */
    // 展开一体柜下拉：未绑定台区时提示并收起
    onCabinetVisibleChange(visible) {
      if (!visible) return
      if (!this.form.transformer_id) {
        this.$message.warning("请先绑定台区信息")
        this.$nextTick(() => {
          if (this.$refs.cabinetSelect) this.$refs.cabinetSelect.blur()
        })
        return
      }
      this.loadCabinetOptions(this.form.transformer_id)
    },

    // 获取指定台区下的所有一体柜（不分页）
    loadCabinetOptions(transformerId) {
      if (!transformerId) return Promise.resolve([])
      this.cabinetLoading = true
      return getPowerCabinetList({ pagesize: 100000, power_transformer_id: transformerId }).then((res) => {
        const payload = this.pickApiPayload(res)
        const list = payload.data || payload.list || []
        const options = list.filter((item) => {
          return !item.del && String(item.power_transformer_id) === String(transformerId)
        })
        // 保留当前已选中的一体柜，避免下拉数据未返回时名称丢失
        if (this.form.cabinet_id && !options.some((item) => item.ID === this.form.cabinet_id)) {
          options.unshift({ ID: this.form.cabinet_id, name: this.form.cabinet_name })
        }
        this.cabinetOptions = options
        return options
      }).catch(() => {
        this.cabinetOptions = []
        return []
      }).finally(() => {
        this.cabinetLoading = false
      })
    },

    onCabinetChange(val) {
      const selected = this.cabinetOptions.find((item) => item.ID === val)
      this.form.cabinet_name = selected ? selected.name : ""
    }
  }
}
</script>

<style lang="scss" scoped>
.ks-device-manage {
  .search-card {
    margin-bottom: 12px;

    ::v-deep .el-card__body {
      padding-bottom: 4px;
    }

    ::v-deep .el-form-item {
      margin-bottom: 12px;
    }
  }

  .table-card {
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .card-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
    }

    .card-sub-title {
      font-size: 12px;
      color: #909399;
    }

    .cell-sub {
      font-size: 12px;
      color: #909399;
      line-height: 18px;
    }

    .btn-danger {
      color: #f56c6c;
    }
  }

  .my-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .drawer-body {
    padding: 4px 10px 20px;
  }

  .drawer-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 10px;
    border-top: 1px solid #ebeef5;
  }

  .form-unit {
    margin-left: 8px;
    font-size: 12px;
    color: #606266;
  }

  .dialog-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
